/**
 * Approval Thresholds Configuration
 *
 * This file contains configurable thresholds for order approval logic.
 * Modify these values to change when orders require manager approval.
 */

/**
 * Orders exceeding this amount (in GBP) require manager approval.
 * Default: £1000
 */
export const BUDGET_THRESHOLD = 1000

/**
 * Future: Could add more thresholds here like:
 * - Per-supplier thresholds
 * - Per-engineer thresholds
 * - Daily spend limits
 * - etc.
 */

/**
 * Reasons an order can be routed for approval (APR-003). Values mirror the
 * backend ApprovalReason enum; config drives the pill label + colours in the
 * approval queue.
 */
export type ApprovalReasonType =
  | 'basket_value'
  | 'weekly_limit'
  | 'restricted_item'
  | 'restricted_category'
  | 'restricted_supplier'
  | 'restricted_branch'

export const APPROVAL_REASON_CONFIG: Record<
  ApprovalReasonType,
  { label: string; bg: string; text: string }
> = {
  weekly_limit: { label: 'Weekly spending limit exceeded', bg: 'bg-amber-50', text: 'text-amber-700' },
  basket_value: { label: 'Basket value threshold', bg: 'bg-blue-50', text: 'text-blue-700' },
  restricted_item: { label: 'Restricted item', bg: 'bg-red-50', text: 'text-red-700' },
  restricted_category: {
    label: 'Restricted category',
    bg: 'bg-orange-50',
    text: 'text-orange-700',
  },
  restricted_supplier: {
    label: 'Restricted supplier',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
  },
  restricted_branch: {
    label: 'Restricted branch',
    bg: 'bg-teal-50',
    text: 'text-teal-700',
  },
}
